import {FC} from 'react';

type PointsIcon = FC<{
  size?: number;
}>;

const Points: PointsIcon = ({size = 16}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z"
        fill="#FFCF00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6487 16.1137C14.4906 16.1137 15.1731 15.4312 15.1731 14.5893V6.60358C15.1731 5.7617 14.4906 5.07922 13.6487 5.07922H5.66295C4.82107 5.07922 4.13859 5.7617 4.13859 6.60358C4.13859 7.44547 4.82107 8.12794 5.66295 8.12794L9.96858 8.12794L5.35549 12.741C4.76019 13.3363 4.76019 14.3015 5.35549 14.8968C5.95079 15.4921 6.91596 15.4921 7.51126 14.8968L12.1244 10.2837V14.5893C12.1244 15.4312 12.8068 16.1137 13.6487 16.1137Z"
        fill="#835111"
      />
    </svg>
  );
};

export default Points;
